


















































































import * as R from 'ramda'
import moment from 'moment-timezone'

import { mapGetters } from 'vuex'

import { PatientExerciseTypes } from '@/jsonapi/PatientExercise'
import { ModuleNames } from '@/store/module-names'
import { GetterNames } from '@/store/modules/exercise-program/keys'
import { UserActionContexts } from '@/constants/urls'

import StatusLabel from '@/components/sub-components/StatusLabel.vue'
import ConfirmDeleteActionDialog from '@/components/dialog/ConfirmDeleteActionDialog.vue'

export default {
  components: {
    StatusLabel,
    ConfirmDeleteActionDialog,
  },
  props: {
    exerciseSession: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Order',
          align: 'end',
          sortable: false,
          value: 'order',
        },
        {
          text: 'Type',
          align: 'center',
          sortable: false,
          value: 'type',
        },
        {
          text: 'Exercise Name',
          value: 'exerciseName',
          sortable: false,
        },
        {
          text: 'Reps',
          value: 'reps',
          sortable: false,
        },
        {
          text: 'Sets',
          value: 'sets',
          sortable: false,
        },
        {
          text: 'Equipment',
          value: 'equipment',
          sortable: false,
        },
        {
          text: 'Resistance',
          value: 'resistance',
          sortable: false,
        },
        {
          text: 'Time',
          value: 'timeMin',
          sortable: false,
        },
      ],
      showDeleteExerciseSessionDialog: false,
    }
  },
  computed: {
    exercisesForTable() {
      return [...this.combinedExercises]
        .sort((a, b) => (a.order > b.order ? 1 : -1))
        .map((exercise, index) => ({
          ...exercise,
          displayOrder: exercise.order ? exercise.order + 1 : index + 1,
        }))
    },
    combinedExercises() {
      return R.concat(this.exerciseSession.cardioExercises, this.exerciseSession.strengtheningExercises)
    },
    formattedExerciseSessionDate() {
      return moment(this.exerciseSession.date).format('DD MMMM YYYY')
    },
    editExerciseSessionRoute() {
      return {
        name: 'edit-exercise-session',
        params: {
          context: UserActionContexts.Edit,
          program_id: this[GetterNames.chosenExerciseProgramId],
          exercise_session_id: this.exerciseSession.id,
        },
      }
    },
    exerciseSessionIsInProgress() {
      return this.exerciseSession.startTimestamp && !this.exerciseSession.endTimestamp ? true : false
    },
    exerciseSessionIsComplete() {
      return this.exerciseSession.startTimestamp && this.exerciseSession.endTimestamp ? true : false
    },
    ...mapGetters(ModuleNames.exerciseProgram, [GetterNames.chosenExerciseProgramId]),
  },
  methods: {
    isStrengthExercise(exercise) {
      return exercise.type === PatientExerciseTypes.Strength
    },
    openDeleteExerciseSessionDialog() {
      this.showDeleteExerciseSessionDialog = true
    },
    closeDeleteExerciseSessionDialog() {
      this.showDeleteExerciseSessionDialog = false
    },
    deleteExerciseSessionAction() {
      this.$emit('deleteExerciseSessionAction', {
        exerciseSessionId: this.exerciseSession.id,
        patientExerciseIds: this.exerciseSession.patientExerciseIds || [],
      })
    },
  },
}
